import store from '@/store';
// import { renew } from '@/utils/auth';
import { baseURL } from '@/utils/constants';

export async function fetchURL (url, opts) {
  opts = opts || {};
  opts.headers = opts.headers || {};

  let { headers, ...rest } = opts;

  const res = await fetch(`${baseURL}${url}`, {
    headers: {
      'X-Auth': store.state.jwt,
      ...headers
    },
    ...rest
  });

  // if (res.headers.get('X-Renew-Token') === 'true') {
  //   await renew(store.state.jwt);
  // }

  return res;
}

export async function fetchJSON (url, opts) {
  const res = await fetchURL(url, opts);

  if (res.status === 200) {
    return res.json();
  } else {
    throw new Error(res.status);
  }
}

export function removePrefix (url) {
  if (url.startsWith('/cloud#')) {
    url = url.slice(7);
  }
  else if (url.startsWith('/bin#')) {
    url = '//bin' + url.slice(5);
  }
  else if (url.startsWith('/bak#')) {
    url = '//bak' + url.slice(5);
  }
  else if (url.startsWith('/shdd#')) {
    url = '//shdd' + url.slice(6);
  }
  else if (url.startsWith('/sec#')) {
    url = '//sec' + url.slice(5);
  }
  if (url.startsWith('/cloud/#')) {
    url = url.slice(8);
  }
  else if (url.startsWith('/bin/#')) {
    url = '//bin' + url.slice(6);
  }
  else if (url.startsWith('/bak/#')) {
    url = '//bak' + url.slice(6);
  }
  else if (url.startsWith('/shdd/#')) {
    url = '//shdd' + url.slice(7);
  }
  else if (url.startsWith('/sec/#')) {
    url = '//sec' + url.slice(6);
  }
  else  if (url.startsWith('/cloud')) {
    url = '/';
  }
  else if (url.startsWith('/bin')) {
    url = '//bin/';
  }
  else if (url.startsWith('/bak')) {
    url = '//bak/';
  }
  else if (url.startsWith('/shdd')) {
    url = '//shdd/';
  }
  else if (url.startsWith('/sec')) {
    url = '//sec/';
  }

  if (url === '') url = '/';
  if (url[0] === '#') url = url.substring(1);
  if (url[0] !== '/') url = '/' + url;

  return url;
}

